import React, { useState, useEffect } from 'react';
import { Typography, Row, Col, Card, Tag, Spin, Alert, Space } from 'antd';
import { EnvironmentOutlined, CalendarOutlined, GlobalOutlined } from '@ant-design/icons';
import { getEvents } from '../services/eventsService';

const { Title, Text } = Typography;

function EventCard({ event }) {
  const formatDate = dateString => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <Card
      cover={
        <img
          alt={event.name}
          src={event.image_url || 'https://source.unsplash.com/random?event'}
          style={{ height: 200, objectFit: 'cover' }}
        />
      }
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: '4px solid black',
        borderRadius: 12,
      }}
    >
      <Card.Meta
        title={<Title level={4}>{event.name}</Title>}
        description={
          <Space direction="vertical" style={{ width: '100%' }}>
            <Text type="secondary">{event.description}</Text>

            <Space>
              <CalendarOutlined />
              <Text>{formatDate(event.start_date)}</Text>
            </Space>

            {event.places?.name && (
              <Space>
                <EnvironmentOutlined />
                <Text>
                  {event.places.name}
                  {event.places.address && ` - ${event.places.address}`}
                </Text>
              </Space>
            )}

            {event.ticket_url && (
              <Space>
                <GlobalOutlined />
                <a
                  href={
                    event.ticket_url.includes('http')
                      ? event.ticket_url
                      : `http://${event.ticket_url}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Website
                </a>
              </Space>
            )}
          </Space>
        }
      />
    </Card>
  );
}

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getEvents();
        setEvents(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px' }}>
        <Alert message={error} type="error" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2} style={{ marginBottom: '24px' }}>
        Events
      </Title>

      {events.length === 0 ? (
        <Text>No events found.</Text>
      ) : (
        <Row gutter={[24, 24]}>
          {events.map(event => (
            <Col key={event.id} xs={24} sm={12} md={8}>
              <EventCard event={event} />
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}

export default Events;
